import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from ".././../constants/Global";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import DataService from ".././../services/tutorial.service";
import Demo from "../crop/Demo";
import { actlistData } from "../../actions/index";
import { getSeason, getAlpha } from "../../Helpers/Helpers";
import { auctiondefaultLogo } from "../../constants/Images";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import $ from "jquery";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import ImageCropper1 from "../cropper/ImageCropper";
import ImageCropper2 from '../utils/Demo';
import { getDatabase, ref, remove, push, onValue, set, off, update } from "firebase/database";

function Addauction(match) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const getpageData = useSelector((state) => state.setactlistData);
  const loginuser = useSelector((state) => state.setUserlog);
  const [isDisabled, setDisabled] = useState(false);
  const [auctime, setauctime] = useState("");
  const history = useHistory({ forceRefresh: true });
  let logo_pic = "";
  const [cid, setCid] = useState(loginuser["cid"]);
  const [token, settoken] = useState(loginuser["token"]);
  const [admin_id, setadminid] = useState(localStorage.getItem('admin_id'));
  const [admin_name, setadmin_name] = useState(localStorage.getItem('admin_name'));

  const [croppedImage, setCroppedImage] = useState("");
  const updtoken = useSelector((state) => state.updtoken);
  const updtoken2 = useSelector((state) => state.updtoken2);

  const onSubmit = (values) => {

    if (!values.dt) {
      toast.error("Date field is missing!", { theme: "colored", position: "top-center", autoClose: 2000 });
      return;
    }

    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });


    if (document.getElementById("logo_pic") != null) {
      logo_pic = document.getElementById("logo_pic").value;
    }

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([{ cid: cid, token: token }]),
      },
    };

    values["logo_pic"] = croppedImage;
    localStorage.setItem('auction_type', values.acttype)
    values["isadmin"] = admin_id;

    if (auctime) {

      values["atm"] = auctime.$H + ":" + auctime.$m + ":00";
    }
    else {
      values["atm"] = "00:00";

    }

    DataService.addAuction(values, hdr)
      .then((res) => {
        let response = res.data;
        //  console.log('response')
        //  console.log(response)
        toast.dismiss(toastContainerId);


        if (response.success == true) {

          const db = getDatabase();

          set(ref(db, 'map/info/user/' + cid), {
            "type": "1", "upd": "1", 'id': response.data.new.aid, "detail": {
              "aname": values.aname,
              "acttype": values.acttype,
              "atm": values.atm,
              "logo": response.data.new.logo,
              "bidup": values.bidup,
              "dt": values.dt,
              "player": values.player,
              "totalpoint": values.totalpoint,
              "minbid": values.minbid,
              "minplayer": values.minplayer,
              "isadmin": admin_id,
            }, "tkn": updtoken2
          });
          set(ref(db, 'map/info/admin_notifications/auctionadded'), {
            'cid': "", 'id': response.data.new.aid, "detail": {
              "aname": values.aname,
              "acttype": values.acttype,
              "atm": values.atm,
              "logo": response.data.new.logo,
              "bidup": values.bidup,
              "dt": values.dt,
              "player": values.player,
              "totalpoint": values.totalpoint,
              "minbid": values.minbid,
              "minplayer": values.minplayer,
              "isadmin": admin_id,
            }, "tkn": updtoken2
          });


          if (values["logo_pic"] != "") {
            var data = {};
            data['work13'] = 3;
            update(ref(db, 'map/info/datastatus/' + response.data.new.aid), data);
            var workhistory = {};
            var currentTime = new Date();  // Store the current time in a variable
            workhistory['worktyp'] = 'work13';
            workhistory['id'] = admin_id;
            workhistory['name'] = admin_name;
            workhistory['timestamp'] = currentTime.toISOString();
            workhistory['aname'] = values.aname;
            workhistory['aid'] = response.data.new.aid;


            push(ref(db, 'map/info/workhistory'), workhistory);
          }
          if (values['atm'] != '00:00') {

            var data = {};
            data['work10'] = 3;
            update(ref(db, 'map/info/datastatus/' + response.data.new.aid), data);
            var workhistory = {};
            var currentTime = new Date();  // Store the current time in a variable

            workhistory['worktyp'] = 'work10';
            workhistory['id'] = admin_id;
            workhistory['name'] = admin_name;
            workhistory['timestamp'] = currentTime.toISOString();
            workhistory['aname'] = values.aname;
            workhistory['aid'] = response.data.new.aid;
            push(ref(db, 'map/info/workhistory'), workhistory);

          }

          setauction(response.data.aid, values.aname);
          let submitdata = [response.data.new];
          let responsedata = {};
          if (getpageData == 0) {
            responsedata = {
              responsedata: {
                path: response.data.path,
                cid: cid,
                list: [...submitdata],
              },
            };
          } else {
            responsedata = {
              responsedata: {
                path: response.data.path,
                cid: cid,
                list: [...submitdata, ...getpageData.responsedata.list],
              },
            };
          }
          dispatch(actlistData(responsedata));
          toast.success(response.msg, {
            theme: "dark",
            position: "bottom-center",
          });
          localStorage.setItem("auction_tm", values['atm']);

          history.push(BASE_PATH + "auction-detail");
        } else {
          toast.error('Fields missing', {
            theme: "colored",
            position: "bottom-center",
          });
        }

        setDisabled(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", {
          theme: "colored",
          position: "bottom-center",
        });
        setDisabled(false);
      });
  };

  const setauction = (ai, an) => {
    localStorage.setItem("auction_id", ai);
    localStorage.setItem("auction_name", an);
  };
  useEffect(() => {
    // localStorage.setItem("lid",0)
    if (localStorage.getItem("lid")) {
      setValue("totalpoint", 100000);
      setValue("minbid", 1000);
      setValue("bidup", 1000);
      setValue("player", 11);
      setValue("minplayer", 0);
    }
    $(".crop-default img").attr("src", auctiondefaultLogo);
    $(".crop-default").click(function () {
      $("#crop-pic").click();
    });
  }, [Demo]);

  return (
    <>
      <div style={{ touchAction: "none" }}>
        <Navigationtitle data={match} />

        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <div className="row text-color">
              <div id="contact-us" className="reg-area">
                <div className="container-fluid">
                  <div className="row">
                    <div className="reg-items">
                      <div className="col-md-5  reg-form">
                        <div className="row">
                          <form
                            onSubmit={handleSubmit(onSubmit)}
                            action=""
                            autoComplete="off"
                            encType="multipart/form-data"
                          >
                            {/* <div className="col-md-12"> */}
                            <div className="col-md-12 ">
                              <div className="form-group text-box-margin addauc-div-margin ">
                                <div className="col-md-2">
                                  <label className="edit-label" typeof="type">Auction Logo</label>
                                  <div style={{ clear: "both" }}></div>
                                </div>
                                <div className="col-md-8">
                                  {localStorage.getItem('crp_typ') == 0 ?
                                    <ImageCropper2
                                      croppedImage={croppedImage}
                                      defaultImage={auctiondefaultLogo}
                                      setCroppedImage={setCroppedImage}
                                    /> :
                                    <ImageCropper1
                                      croppedImage={croppedImage}
                                      defaultimage={auctiondefaultLogo}
                                      setCroppedImage={setCroppedImage}
                                    />
                                  }
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin" style={{ marginBottom: "0" }}>
                                <div className="col-md-2">
                                  <label className="edit-label" typeof="type"> Sports Type* </label>
                                </div>
                                <div className="col-md-4">
                                  <select
                                    className="form-control addform-control"
                                    type="text"
                                    {...register("acttype", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  >
                                    <option value={0}>Cricket</option>
                                    <option value={1}>Football</option>
                                    <option value={2}>Volleyball</option>
                                    <option value={3}>Tennis</option>
                                    <option value={4}>Badminton</option>
                                    <option value={5}>Kabaddi</option>
                                    <option value={6}>Pickleball</option>
                                    <option value={7}>Table Tennis</option>
                                    <option value={8}>Hockey</option>
                                    <option value={11}>Basketball</option>
                                    <option value={12}>Baseball</option>
                                  </select>
                                  {errors.acttype && (
                                    <p className="text-error">
                                      {errors.acttype.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="form-group text-box-margin addauc-div-margin ">
                                <div className="col-md-1">
                                  <label className="edit-label" typeof="srtkey"> Season </label>
                                </div>
                                <div className="col-md-3">
                                  {" "}
                                  <select
                                    className="form-control addform-control season-control"
                                    type="text"
                                    {...register("ses", {})}
                                  >
                                    <option value="">--select--</option>
                                    {getSeason()?.map((dt, key) => {
                                      return <option key={key} value={dt}>{dt}</option>;
                                    })}
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  <label className="edit-label" typeof="aname"> Auction Name* </label>
                                </div>
                                <div className="col-md-8">
                                  <input
                                    className="form-control addinput-control"
                                    placeholder="Auction Name"
                                    type="text"
                                    {...register("aname", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.aname && (
                                    <p className="text-error">
                                      {errors.aname.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  <label className="edit-label" typeof="dt"> Auction Date* </label>
                                </div>
                                <div className="col-md-4 addauc-time-margin">
                                  {" "}
                                  <input
                                    min={moment().format("YYYY-MM-DD")}
                                    className="form-control addinput-control"
                                    type="date"
                                    {...register("dt", {
                                      // required: true,
                                      // required: "required field.",
                                    })}
                                  />
                                  {/* {errors.dt && (
                                    <p className="text-error">
                                      {errors.dt.message}
                                    </p>
                                  )} */}
                                </div>

                                <div className="form-group text-box-margin  addauc-topmargin addauc-time-margin ">
                                  <div className="col-md-3 auctime time-div">
                                    {" "}
                                    <LocalizationProvider
                                      className="timepick "
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <TimePicker
                                        label="Auction Time"
                                        className="picker-time"
                                        // className="mypicker"
                                        value={auctime}
                                        onChange={(e) => setauctime(e)}
                                        PopperProps={{
                                          popperOptions: {
                                            modifiers: {
                                              preventOverflow: {
                                                enabled: true,
                                              },
                                            },
                                          },
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  <label className="edit-label" typeof="totalpoint">
                                    {" "}
                                    Points Per Team*{" "}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Points"
                                    className="form-control addinput-control"
                                    {...register("totalpoint", {
                                      required: true,
                                      required: "required field.",
                                      validate: (value) =>
                                        value >= 0 || "Value must not be negative."
                                    })}
                                  />
                                  {errors.totalpoint && (
                                    <p className="text-error">
                                      {errors.totalpoint.message}
                                    </p>
                                  )}
                                </div>
                                {/* <div className="col-md-1 padding-top-16px">
                                  <label typeof="totalpoint"> Units </label>
                                </div>
                                <div className="col-md-3">
                                  {" "}
                                  <input
                                    type="text"
                                    placeholder="CR/LAC"
                                    className="form-control"
                                    {...register("unit")}
                                  />
                                  {errors.unit && (
                                    <p className="text-error">
                                      {errors.unit.message}
                                    </p>
                                  )}
                                </div> */}
                                {/* <div className="col-md-1 padding-top-16px">
                                  <label typeof="totalpoint"> Unit prefix </label>
                                </div>
                                <div className="col-md-3">
                                  {" "}
                                  <select
                                    className="form-control"
                                    type="text"
                                    {...register("unitpfix", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  >
                                    <option value={0}>Rs</option>
                                    <option value={1}>$</option>
                                    <option value={2}>Cr</option>
                                    <option value={3}>M</option>
                                    <option value={4}>Badminton</option>
                                  </select>
                                </div> */}
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label className="edit-label" typeof="minbid"> Base Bid* </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Minimum Bid"
                                    className="form-control addinput-control"
                                    {...register("minbid", {
                                      required: true,
                                      required: "required field.",
                                      validate: (value) =>
                                        value >= 0 || "Value must not be negative."
                                    })}
                                    step="any"
                                  />
                                  {errors.minbid && (
                                    <p className="text-error">
                                      {errors.minbid.message}
                                    </p>
                                  )}
                                </div>

                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label className="edit-label" typeof="bidup">
                                    {" "}
                                    Bid Increase by*{" "}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Bid Increase"
                                    className="form-control addinput-control"
                                    {...register("bidup", {
                                      required: true,
                                      required: "required field.",
                                      validate: (value) =>
                                        value >= 0 || "Value must not be negative."
                                    })}
                                    step="any"
                                  />
                                  {errors.bidup && (
                                    <p className="text-error">
                                      {errors.bidup.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin ">
                                <div className="col-md-2">
                                  {" "}
                                  <label className="edit-label" typeof="player">
                                    {" "}
                                    Player Per Team*{" "}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Player per Team"
                                    className="form-control addinput-control"
                                    {...register("player", {
                                      required: true,
                                      required: "required field.",
                                      validate: (value) =>
                                        value >= 0 || "Value must not be negative."
                                    })}
                                  />
                                  {errors.player && (
                                    <p className="text-error">
                                      {errors.player.message}
                                    </p>
                                  )}
                                </div>
                                <span className="padding-left-16px">
                                  (Max Limit)
                                </span>
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label className="edit-label" typeof="player">
                                    {" "}
                                    Player Per Team{" "}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Player per Team"
                                    className="form-control addinput-control"
                                    {...register("minplayer", {
                                      required: false,
                                      validate: (value) =>
                                        value >= 0 || "Value must not be negative."
                                      // required: "required field.",
                                    })}
                                  />
                                  {errors.minplayer && (
                                    <p className="text-error">
                                      {errors.minplayer.message}
                                    </p>
                                  )}
                                </div>
                                <span className="padding-left-16px">
                                  (Min Limit)
                                </span>
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px"></div>
                            {/* </div> */}

                            <div className="col-md-12">
                              <button
                                className="button addauc-button"
                                type="submit"
                                style={{
                                  backgroundColor: "#186CC2",
                                  borderRadius: "5px",
                                  marginLeft: "12px",
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Addauction;
